// @flow strict

import React, { type Node, Fragment } from 'react';

import type { SocialMediaSVGProps } from '~components/icons/social-media/social-media-icon';

/**
 * Instagram icon
 *
 * @param {SocialMediaSVGProps} props - icon props
 *
 * @returns {Node}
 */
export const InstagramIcon = ({ color }: SocialMediaSVGProps): Node => {
  return (
    <Fragment>
      <defs>
        <path id="instagram__a" d="M0 0.018L18.882 0.018 18.882 18.9 0 18.9z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H35V35H0z" />
        <g transform="translate(9 10)">
          <mask id="instagram__b" fill="#fff">
            <use xlinkHref="#instagram__a" />
          </mask>
          <path
            className="instagram"
            fill={color}
            d="M5.374 1.637c-2.07 0-3.756 1.684-3.756 3.755v8.134c0 2.07 1.685 3.756 3.756 3.756h8.134c2.07 0 3.755-1.685 3.755-3.756V5.392c0-2.07-1.684-3.755-3.755-3.755H5.374zM13.508 18.9H5.374C2.411 18.9 0 16.49 0 13.526V5.392C0 2.43 2.41.018 5.374.018h8.134c2.963 0 5.374 2.411 5.374 5.374v8.134c0 2.963-2.411 5.374-5.374 5.374z"
            mask="url(#instagram__b)"
          />
          <path
            className="instagram"
            fill={color}
            d="M9.45 6.157c-1.816 0-3.293 1.477-3.293 3.293s1.477 3.293 3.293 3.293 3.293-1.477 3.293-3.293-1.477-3.293-3.293-3.293m0 8.243c-2.73 0-4.95-2.22-4.95-4.95S6.72 4.5 9.45 4.5s4.95 2.22 4.95 4.95-2.22 4.95-4.95 4.95M16.2 4.05c0 .746-.604 1.35-1.35 1.35-.746 0-1.35-.604-1.35-1.35 0-.746.604-1.35 1.35-1.35.746 0 1.35.604 1.35 1.35"
          />
        </g>
      </g>
    </Fragment>
  );
};
